module.exports = __webpack_public_path__ + "static/media/SpringVille_PH2_1.319861ee.webp";